import React from 'react';
import {
  useImpersonation,
} from 'core/context/impersonation';
import Dialog from 'pages/Dashboard/components/Dialog';
import Button from 'pages/Dashboard/components/Button';
import {
  APP_ROUTES,
} from 'views/EMR/router';
import {
  ImpersonationUserCard,
} from 'views/EMR/PopulateSupport/ImpersonateDialog';

export default function ImpersonationActiveDialog() {
  const {
    isImpersonating,
    stopImpersonation,
    impersonation,
  } = useImpersonation();

  return isImpersonating ? (
    <Dialog
      open
      onClose={() => {}}
      title={(
        <div className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold">
            Impersonation session active
          </h2>
          <p className="text-sm text-slate-700 font-medium">
            Currently impersonating
          </p>
        </div>
      )}
      className="!w-[36rem]"
      maxWidth="sm"
      hideCloseBtn
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2 min-w-0">
          <ImpersonationUserCard
            userName={impersonation?.userName ?? ''}
            userEmail={impersonation?.userEmail ?? ''}
            organizationName=""
          />
        </div>
        <div className="flex gap-4 items-center justify-end">
          <Button
            variant="outlined"
            onClick={stopImpersonation}
            className="w-full"
          >
            Switch User
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.replace(APP_ROUTES.EMR.ROOT)}
            className="w-full !bg-amber-600 hover:!bg-amber-700 !text-white"
          >
            Open App as
            {' '}
            {impersonation?.userName}
          </Button>
        </div>
      </div>
    </Dialog>
  ) : null;
}
